import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import {
  withLatestFrom,
  filter,
  debounceTime,
  mergeMap,
  concatMap,
} from 'rxjs/operators';
import { Action } from 'redux';
import { CreateOwnership } from '../action-creators';
import AppState from '../../state';
import { NewOwnership } from '@services/ownership/types/new-ownership';
import { ownersList } from '../selectors';
import { UPDATE_FIELD } from '../../release/actions';
import { UpdateField } from '@webapp/store/release/action-creators';
import { trackList } from '../../tracks/selectors';
import { NoOp } from '../../ui/action-creators';
import { getRecordLabelSplit } from '../../../sdk/record-labels';

/**
 *
 * This effect creates a owner after a successful Record Label on Release Edition
 *
 */

export const createOwnerAfterLabelEdition = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, UpdateField<'recordLabel'>>(UPDATE_FIELD),
    filter((action) => action.field === 'recordLabel'),
    debounceTime(2000),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const tracks = trackList(state.tracks.tracks, state.release.release?.id);

      return tracks
        .filter((track) => !!track.id)
        .map(async (track) => {
          const labelOwner = await getRecordLabelAsOwner(
            track.id as string,
            action.value as string,
            state
          );

          if (labelOwner) {
            return new CreateOwnership(labelOwner);
          }

          return new NoOp();
        });
    }),
    concatMap((actions) => actions)
  );

const getRecordLabelAsOwner = async (
  assetId: string,
  name: string,
  state: AppState
): Promise<NewOwnership | undefined> => {
  const owners = ownersList(state.ownership, assetId);
  const recordLabel = state.recordLabels.list.find((o) => o.name === name);

  if (!(recordLabel?.id && state.artist.active?.id)) {
    return;
  }

  try {
    const split = await getRecordLabelSplit(
      recordLabel?.id,
      state.artist.active?.id
    );

    const exists = owners.find(
      (o) => o.ownerType === 'RECORD_LABEL' && o.name === recordLabel.name
    );

    if (!exists) {
      return {
        assetId,
        assetType: 'TRACK',
        ownershipType: 'OWNER',
        name: recordLabel.name,
        contact: 'MISSING_CONTACT',
        contactType: 'email',
        ownerType: 'RECORD_LABEL',
        ownerId: `${recordLabel.ownerId}#${recordLabel.id}`,
        split,
      };
    }
  } catch {
    // pass
  }
};
